






import { defineComponent, reactive, toRefs, ref, onMounted } from '@vue/composition-api';
import http from "../../plugins/http"
import PdfRenderArea from "../../components/PdfRenderArea.vue"

export interface Data {
  base_sheet_id: string
  base64Pdf: string
  errors: string[]
}

export default defineComponent({
  components: {
    "pdf-render-area": PdfRenderArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      base_sheet_id: "",
      base64Pdf: "",
      errors: new Array<string>()
    });

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.base_sheet_id = context.root.$route.params.base_sheet_id;
      await http.get(`/api/saiten_input/download_question_pdf/${state.base_sheet_id}`).then(response => {
        context.root.$nextTick(() => {
          state.base64Pdf = response.data.base64_pdf;
        });
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`PDFの取得処理に失敗しました。\n${error.response.data.errors[0]}`);
        }else{
          alert(`PDFの取得処理に失敗しました。`);
        }
        window.close();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
    };
  }
});
